/**
 * Текст ошибки моста оболочки — человеку, а не протоколом.
 *
 * Одно место на все четыре точки выбора файла: композер и три аватара.
 * Коды контракта («too-large», «unreadable», «ipc-failed», …) наружу не
 * показываются никогда — только локализованная фраза.
 */
import { tf } from "../i18n";
import { ShellPickFailure } from "../shell/desktopFilePicker";
import { humanSize } from "./MediaViewer";

export function shellPickErrorText(err: unknown): string {
  if (err instanceof ShellPickFailure && err.code === "too-large") {
    const size = humanSize(err.size ?? 0);
    const limit = humanSize(err.maxBytes ?? 0);
    // Без обоих чисел фраза «слишком большой: , предел ,» бессмысленна —
    // тогда честнее общая ошибка.
    if (size && limit) {
      return tf("picker.shellTooLarge", { name: err.fileName ?? "", size, limit });
    }
  }
  return tf("picker.shellFailed");
}
